import PendingRx from "./PendingRx";

export default PendingRx;
